import { gridGen } from "./gridGen"

var xmapped;
var ymapped;

export function engine(dataGraphics){
    const ctx = dataGraphics.canvas.getContext('2d')
    const gridData = {
        ctx: ctx,
        xInt: dataGraphics.nx,
        yInt: dataGraphics.ny,
        width: dataGraphics.width,
        height: dataGraphics.height,
        scale: dataGraphics.scale,
        xmapped: xmapped,
        ymapped: ymapped,
    }

    gridGen(gridData)

    return engine;

}